import { useNavigate } from "react-router-dom";

import { FileSpreadsheet, FolderTree, Layers, Settings } from "lucide-react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";

interface ConfigCard {
  title: string;
  description: string;
  icon: React.ElementType;
  url: string;
  available: boolean;
}

const configOptions: ConfigCard[] = [
  {
    title: "Mapeo de Cuentas",
    description:
      "Vincule las cuentas del plan contable con una estructura estandarizada para generar estados financieros.",
    icon: FileSpreadsheet,
    url: "/contabilidad/configuracion/mapeo",
    available: true,
  },
  {
    title: "Grupos de Cuenta",
    description:
      "Administre los grupos de cuenta utilizados para clasificar las cuentas en los estados financieros.",
    icon: FolderTree,
    url: "/contabilidad/configuracion/grupos-cuenta",
    available: true,
  },
  {
    title: "Categorías Contables",
    description:
      "Configure la valoración y la asignación de cuentas (ingresos, gastos, inventario, variación) por categoría de producto.",
    icon: Layers,
    url: "/contabilidad/configuracion/categorias",
    available: true,
  },
];

export default function ConfiguracionPage() {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto w-[80vw] space-y-6 py-6">
      <div className="flex items-center gap-3">
        <div className="rounded-lg bg-primary/10 p-2 text-primary">
          <Settings className="h-6 w-6" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Configuracion Contable</h1>
          <p className="text-sm text-muted-foreground">
            Configure la estructura de cuentas para estados financieros
          </p>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {configOptions.map((option) => {
          const Icon = option.icon;
          return (
            <Card
              key={option.title}
              className={`cursor-pointer transition-all hover:shadow-md ${
                option.available
                  ? "hover:border-primary"
                  : "cursor-not-allowed opacity-50"
              }`}
              onClick={() => option.available && navigate(option.url)}
            >
              <CardHeader className="pb-2">
                <div className="flex items-center gap-2">
                  <div
                    className={`rounded-lg p-2 ${
                      option.available
                        ? "bg-primary/10 text-primary"
                        : "bg-muted text-muted-foreground"
                    }`}
                  >
                    <Icon className="h-5 w-5" />
                  </div>
                  <CardTitle className="text-base">{option.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription>{option.description}</CardDescription>
                {!option.available && (
                  <span className="mt-2 inline-block rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground">
                    Proximamente
                  </span>
                )}
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
